const choosedummyData = [
  {
    id: 1,
    title: "Media Measurement",
    description:
      "We offer advanced media measurement solutions to track your brand's performance.",
    image: "https://i.ytimg.com/vi/uKOiHwht1FA/maxresdefault.jpg",
  },
  {
    id: 2,
    title: "Expert Team",
    description:
      "Our team consists of experts in the field with years of experience.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTorBKo4zemh7Dai5VqdqYTGCjujVbAa7lP8Q&usqp=CAU",
  },
  // Add more rows as needed
];

export default choosedummyData;
